import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import ShopNav from '../../../components/shopNav/ShopNav';
import NavCategorias from '../../../components/navbar/NavCategorias';
import Footer from '../../../components/footer/footer';
import ServiceHighlights from '../../../components/servicehighlights/ServiceHighlights';
import './marcas.css';

const API_URL = import.meta.env.VITE_API_URL || 'https://api.vintagepro.app';

const Marcas = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedBrand, setSelectedBrand] = useState(null);

  const getBrandImage = (brand) => brand?.logoUrl || brand?.gcpBucketUrl || '';
  const toBrandSlug = (name = '') => name.toLowerCase().replace(/\s+/g, '-');

  const navigate = useNavigate();

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await axios.get(`${API_URL}/stock/brands`);
        setBrands(response.data);
      } catch (err) {
        console.error(err);
        setError('Error al cargar las marcas');
      } finally {
        setLoading(false);
      }
    };

    fetchBrands();
  }, []);

  const openBrandModal = (brand) => {
    setSelectedBrand(brand);
  };

  const closeBrandModal = () => {
    setSelectedBrand(null);
  };

  return (
    <div className="marcas-page">
      <ShopNav />
      <NavCategorias />
      <main className="marcas-page-main">
        <section className="marcas-page-hero marcas-page-elevated-wrap marcas-page-elevated-wrap--hero">
          <div className="container marcas-page-hero-inner">
            <div className="marcas-page-hero-copy">
              <h1 className="display-5">Nuestras Marcas</h1>
              <p className="lead">
                Explora cada marca, descubre su identidad y entra a su catalogo con una experiencia premium.
              </p>
            </div>
            <div className="marcas-page-hero-logo-wrap" aria-hidden="true">
              <img src="/images/VPA.png" alt="Vintage Pro Audio" className="marcas-page-hero-logo" />
            </div>
          </div>
        </section>

        <section className="marcas-page-elevated-wrap">
          <ServiceHighlights />
        </section>

        <section className="container marcas-page-results">
          {loading ? (
            <div className="marcas-page-state text-center">Cargando marcas...</div>
          ) : error ? (
            <div className="alert alert-danger text-center">{error}</div>
          ) : (
            <>
              <div className="marcas-page-results-head">
                <h2 className="marcas-page-results-title">Marcas destacadas</h2>
                <p className="marcas-page-results-meta">{brands.length} marca(s) disponible(s)</p>
              </div>

              <div className="row g-4 marcas-grid">
                {brands.map((brand) => (
                  <div key={brand.id} className="col-6 col-md-4 col-lg-3 marcas-col">
                    <article
                      className="card border-0 h-100 text-center marcas-card"
                      onClick={() => navigate(`/marcas/${toBrandSlug(brand.name)}`)}
                      onKeyDown={(e) => e.key === 'Enter' && navigate(`/marcas/${toBrandSlug(brand.name)}`)}
                      role="button"
                      tabIndex={0}
                    >
                      <span className="marcas-chip">Ver productos</span>

                      <div className="card-body d-flex flex-column align-items-center">
                        <div className="marcas-image-wrap mb-3">
                          {getBrandImage(brand) ? (
                            <img
                              src={getBrandImage(brand)}
                              alt={brand.name}
                              className="img-fluid marcas-image"
                              onError={(e) => { e.currentTarget.style.display = 'none'; }}
                            />
                          ) : (
                            <div className="marcas-image-fallback">Sin imagen</div>
                          )}
                        </div>

                        <h5 className="marcas-title mb-3">{brand.name}</h5>

                        <button
                          className="btn marcas-desc-btn mt-auto"
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            openBrandModal(brand);
                          }}
                        >
                          Ver descripcion
                        </button>
                      </div>
                    </article>
                  </div>
                ))}
              </div>
            </>
          )}
        </section>
      </main>

      <Footer />

      {selectedBrand && (
        <div className="marcas-modal-backdrop" onClick={closeBrandModal}>
          <div className="modal-dialog marcas-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content marcas-modal-content">
              <div className="modal-header marcas-modal-header">
                <div>
                  <h5 className="modal-title marcas-modal-title">{selectedBrand.name}</h5>
                  <p className="marcas-modal-subtitle mb-0">Descripcion de la marca</p>
                </div>
                <button className="btn-close" type="button" aria-label="Cerrar" onClick={closeBrandModal}></button>
              </div>

              <div className="modal-body marcas-modal-body">
                {getBrandImage(selectedBrand) && (
                  <div className="text-center mb-3 marcas-modal-image-wrap">
                    <img
                      src={getBrandImage(selectedBrand)}
                      alt={selectedBrand.name}
                      className="img-fluid marcas-modal-image"
                      onError={(e) => { e.currentTarget.style.display = 'none'; }}
                    />
                  </div>
                )}

                <p className="mb-0 marcas-modal-text">
                  {selectedBrand.description || selectedBrand.shortDescription || 'No hay descripcion disponible para esta marca.'}
                </p>
              </div>

              <div className="modal-footer marcas-modal-footer">
                <button className="btn marcas-modal-close-btn" type="button" onClick={closeBrandModal}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Marcas;